import type { ClassValue } from 'clsx';

import { VFlex, VStack, new__cn as cn } from '@/package';

export const StatisticSummaryCard = ({
  Icon,
  className,
  content,
  title,
}: {
  Icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  className?: ClassValue;
  content: () => React.ReactNode;
  title: string;
}) => {
  return (
    <VFlex
      aria-label={`statistic-summary-card-${title}`}
      className={cn(
        'flex-1 rounded-md px-4 py-2 shadow-sm [&_svg]:size-8 [&_svg]:text-primary-500',
        className,
      )}
      gap={0.5}
      items="center"
    >
      <Icon />

      <VStack>
        <div className="text-body-lg text-gray-600">{title}</div>
        <VStack
          justify="center"
          className="h-[30px] text-body-xl font-semibold text-black"
        >
          {content()}
        </VStack>
      </VStack>
    </VFlex>
  );
};

StatisticSummaryCard.displayName = 'StatisticSummaryCard';
